/* assets/vn-sold-view-lock.js – Complete (SEO first-page freeview + TTL) */
(function(){
  "use strict";

  /* ========= Config ========= */
  var gEl = document.getElementById("vn-sold-global");
  var G = {};
  try{ if(gEl) G = JSON.parse(gEl.textContent||"{}"); }catch(e){}
  if(!G) G = {};
  var LINE_URL    = (G.line_url||'');
  var GLOBAL_HASH = (G.global_hash||'').trim(); // SHA-256 HEX
  var TTL_DAYS    = Number.isFinite(+G.ttl_days) ? (+G.ttl_days) : 7; // 0 = no expiry
  var TTL_MS      = Math.max(0, TTL_DAYS) * 86400000;

  var FREE_ON_SEO       = !!G.freeview_enable;
  var FREE_DOMAINS_RAW  = (G.freeview_domains||'').toString();
  var FREE_TREAT_EMPTY  = !!G.freeview_treat_empty;

  var inlineEl = document.getElementById("vn-sold-inline");
  var inline = null;
  try{ if(inlineEl) inline = JSON.parse(inlineEl.textContent||"{}"); }catch(e){}

  /* ========= Helpers ========= */
  function handleFromUrl(url){
    try{ var u=new URL(url, location.origin);
         var m=u.pathname.match(/\/products\/([^\/\?]+)/);
         return m?decodeURIComponent(m[1]):null; }
    catch(e){ return null; }
  }
  function currentProductHandle(){
    var m = location.pathname.match(/\/products\/([^\/\?]+)/);
    if (m && m[1]) return decodeURIComponent(m[1]);
    var link = document.querySelector('link[rel="canonical"]');
    return link ? handleFromUrl(link.getAttribute('href')) : null;
  }
  function sha256hex(str){
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str))
      .then(buf => Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,'0')).join(''));
  }

  /* ========= Unlock state with TTL ========= */
  function keyGlobalV1(){ return 'vn_sold_pass::global'; }      // old
  function keyGlobalV2(){ return 'vn_sold_pass::global_v2'; }   // {hash,ts}

  function readV2(){
    try{
      var raw = localStorage.getItem(keyGlobalV2());
      if(!raw) return null;
      var obj = JSON.parse(raw);
      if(!obj || typeof obj.hash!=='string' || typeof obj.ts!=='number') return null;
      return obj;
    }catch(e){ return null; }
  }
  function writeV2(hash){
    var obj = {hash: hash, ts: Date.now()};
    try{ localStorage.setItem(keyGlobalV2(), JSON.stringify(obj)); }catch(e){}
    try{ localStorage.removeItem(keyGlobalV1()); }catch(e){}
    return obj;
  }
  function migrateIfNeeded(){
    if (readV2()) return;
    var old = localStorage.getItem(keyGlobalV1());
    if (old && GLOBAL_HASH && old === GLOBAL_HASH){
      writeV2(old);
    }
  }
  function clearV2(){ try{ localStorage.removeItem(keyGlobalV2()); }catch(e){} }

  function hasGlobalUnlock(){
    if (!GLOBAL_HASH) return false;
    migrateIfNeeded();
    var rec = readV2();
    if (!rec || rec.hash !== GLOBAL_HASH) return false;
    if (TTL_MS > 0){
      var age = Date.now() - rec.ts;
      if (age > TTL_MS){ clearV2(); return false; }
      rec.ts = Date.now();
      try{ localStorage.setItem(keyGlobalV2(), JSON.stringify(rec)); }catch(e){}
    }
    return true;
  }
  function setGlobalUnlock(hash){ writeV2(hash); }

  /* ========= One-page freeview (session) ========= */
  function freeKey(){ return 'vn_sold_freeview_path'; } // sessionStorage
  function getFreePath(){ try{ return sessionStorage.getItem(freeKey()) || ''; }catch(e){ return ''; } }
  function setFreePath(p){ try{ sessionStorage.setItem(freeKey(), p); }catch(e){} }
  function clearFreePath(){ try{ sessionStorage.removeItem(freeKey()); }catch(e){} }
  function isFreeForCurrent(){ return getFreePath() === location.pathname; }

  function parseDomains(csv){
    return csv.split(/[\s,]+/).map(function(s){return s.trim().toLowerCase();}).filter(Boolean);
  }
  var FREE_DOMAINS = parseDomains(FREE_DOMAINS_RAW);

  function isSeoReferrer(){
    var ref = document.referrer;
    if (!ref) return !!FREE_TREAT_EMPTY; // 空referrerをSEO扱いにする設定
    try{
      var u = new URL(ref);
      var host = (u.hostname||'').toLowerCase();
      if (!host || host === location.hostname.toLowerCase()) return false; // 同一ドメインはSEO扱いしない
      // ドメイン部分に部分一致で簡易判定（google., yahoo., bing.com など）
      return FREE_DOMAINS.some(function(d){ return d && host.indexOf(d) !== -1; });
    }catch(e){
      return false;
    }
  }

  /* ========= Black cover OFF ========= */
  function unlockSoldGuard(){
    document.documentElement.classList.add('vn-sold-ok');
    var cover = document.getElementById('vn-sold-cover-css');
    if (cover) try{ cover.remove(); }catch(e){}
    var inl = document.getElementById('vn-sold-inline');
    if (inl){
      inl.removeAttribute('data-sold');
      try{ inl.parentNode && inl.parentNode.removeChild(inl); }catch(e){}
    }
  }

  /* ========= Overlay ========= */
  function buildOverlay(){
    var ov = document.createElement('div');
    ov.className = 'vn-sold-ov';
    ov.innerHTML =
      '<div class="vn-sold-box">'
      +  '<div class="vn-sold-title">販売済み商品</div>'
      +  '<div class="vn-sold-desc">販売済み商品を閲覧するにはパスワードが必要です。<br>パスワードを入力して下さい。</div>'
      +  '<input type="password" class="vn-sold-input" id="vn-sold-input" autocomplete="current-password">'
      +  '<button class="vn-sold-btn vn-sold-btn--ok" id="vn-sold-ok">送信</button>'
      +  '<button class="vn-sold-btn vn-sold-btn--cancel" id="vn-sold-cancel">キャンセル</button>'
      +  '<div class="vn-sold-note">'
      +    'パスワードは公式LINEアカウントにご登録されている方のみに配布しております。<br>'
      +    (LINE_URL ? ('<a href="'+LINE_URL+'" target="_blank" rel="noopener">ご登録はコチラ</a>よりお願い致します。') : 'ご登録は公式LINEよりお願い致します。')
      +  '</div>'
      + '</div>';
    return ov;
  }
  function attachOverlay(onSuccess, onCancel){
    var ov = buildOverlay();
    document.documentElement.appendChild(ov);
    var input  = ov.querySelector('#vn-sold-input');
    var ok     = ov.querySelector('#vn-sold-ok');
    var cancel = ov.querySelector('#vn-sold-cancel');
    input && input.focus();

    function cleanup(){ try{ ov.remove(); }catch(e){} }

    function submit(){
      var code = (input.value||'').trim();
      sha256hex(code).then(function(h){
        if (GLOBAL_HASH && h === GLOBAL_HASH){
          setGlobalUnlock(h);
          unlockSoldGuard();
          clearFreePath(); // パス解除後はfreeviewフラグ不要
          cleanup();
          onSuccess && onSuccess();
        } else {
          input.value=''; input.focus(); alert('コードが違います');
        }
      });
    }

    ok.addEventListener('click', submit);
    input.addEventListener('keydown', function(ev){ if(ev.key==='Enter') submit(); });
    cancel.addEventListener('click', function(){ cleanup(); onCancel && onCancel(); });
  }

  /* ========= Product page guard ========= */
  (function(){
    var h = currentProductHandle();
    if(!h || !inline) return;

    if (String(inline.sold_lock) === 'true'){
      // 1) TTL内で既に解除済みなら通常表示
      if (hasGlobalUnlock()){
        unlockSoldGuard();
        return;
      }

      // 2) SEO直ラン1ページ閲覧（セッション）：
      //    - 設定ON かつ (該当ページがすでにfreeview中 もしくは 今回SEOからの流入)
      if (FREE_ON_SEO && (isFreeForCurrent() || isSeoReferrer())){
        setFreePath(location.pathname); // 現在のページだけfreeview
        unlockSoldGuard();              // 黒カバー解除して閲覧許可
        return;
      }

      // 3) それ以外はモーダルでパス要求
      attachOverlay(
        function onOK(){ /* 続行 */ },
        function onCancel(){
          if (document.referrer && document.referrer.indexOf(location.origin) === 0){ history.back(); }
          else { location.href = '/'; }
        }
      );
    }else{
      // SOLDではないページに来たら、freeviewは無関係
      clearFreePath();
    }
  })();

  /* ========= Collections/Search – click guard ========= */
  var fetchCache = new Map();
  function fetchSoldInfo(handle){
    if(!handle) return Promise.resolve(null);
    if(fetchCache.has(handle)) return fetchCache.get(handle);
    var p = fetch('/products/'+encodeURIComponent(handle)+'?view=sold_lock', {credentials:'same-origin'})
      .then(function(res){ if(!res.ok) throw new Error('HTTP '+res.status); return res.json(); })
      .catch(function(){ return null; });
    fetchCache.set(handle, p);
    return p;
  }

  function scanAndWire(root){
    root = root || document;
    var links = Array.from(root.querySelectorAll('a[href*="/products/"]'));
    if(!links.length) return;

    var map = new Map(); // handle -> [anchors]
    links.forEach(function(a){
      var h = handleFromUrl(a.getAttribute('href'));
      if(!h) return;
      if(!map.has(h)) map.set(h, []);
      map.get(h).push(a);
    });

    map.forEach(function(anchors, h){
      fetchSoldInfo(h).then(function(info){
        if(!info || String(info.sold_lock)!=='true') return;

        anchors.forEach(function(a){
          if (a.__vnSoldWired) return;
          a.addEventListener('click', function(ev){
            if (ev.defaultPrevented) return;
            if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) return; // 新規タブ等は素通り
            if (hasGlobalUnlock()) return; // TTL内は通過

            // 同一タブ内の"1ページfreeview"は、そのページパス限定。
            // つまり他ページへ移動しようとしたらfreeviewは無効で、ここでブロック。
            ev.preventDefault(); ev.stopPropagation();
            attachOverlay(
              function onOK(){ location.href = a.href; }, // 成功→遷移
              function onCancel(){ /* stay */ }
            );
          }, true);
          a.__vnSoldWired = true;
        });
      });
    });
  }

  scanAndWire(document);
  new MutationObserver(function(ms){
    ms.forEach(function(m){ (m.addedNodes||[]).forEach(function(n){ if(n.nodeType===1) scanAndWire(n); }); });
  }).observe(document.documentElement, {childList:true, subtree:true});
  window.addEventListener('popstate', function(){ setTimeout(function(){ scanAndWire(document); }, 0); });
  window.addEventListener('pageshow', function(){ setTimeout(function(){ scanAndWire(document); }, 0); });

})();